import { Injectable } from '@angular/core';
import {  Http, Response, Headers} from '@angular/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';
import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
@Injectable()
export class BlogService {
type: string;
private cdtk= "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjZlOWVlZDVjODQ5Yzk1YTVlNjIwYTUyMDMwMTYyMDJiOTBmYzAxNzRkMzA3NDc0OTc1ZmFlMDgyNDdkMGNhNjdiNmFhMzIzM2NmMjgyYjA0In0.eyJhdWQiOiIzIiwianRpIjoiNmU5ZWVkNWM4NDljOTVhNWU2MjBhNTIwMzAxNjIwMmI5MGZjMDE3NGQzMDc0NzQ5NzVmYWUwODI0N2QwY2E2N2I2YWEzMjMzY2YyODJiMDQiLCJpYXQiOjE1MzE0MDA3MjcsIm5iZiI6MTUzMTQwMDcyNywiZXhwIjoxNTYyOTM2NzI3LCJzdWIiOiIiLCJzY29wZXMiOltdfQ.dz0LSq7-jtxzrLmH6KgrNFGBYYq7UHf9n10owKt1JSoUdoLiCJJEmTprHufPiBrzu_6FxwivAUW5gD6yCQicAeVvxqBk1V3lNJduKt8TrCqeJWhqlECRvPp-fRJsbh3ZxsPwysKrAlb2AeWBv_NowO7nRyB4IpUiTatmV_Ud41WdM_pW-hBdJGLlX8-m5wHRYGOyMQay257byTtqOtJHVpouZd8b3Itta2uVX4cVaGgtTosebKfuLYG_xs5yLGMXXuab8pL2e5IdhYsYe1WJ0n-1qUK0ZH26WyLBZzEQ7s7DR3HGJN_YfBRLEDRmphvnYxBeAfiKtl1G4ztFSOksG5Qwxq-YugCODot_AmiNvUVxqRumgzegyx-xJN-Xc7ATbghFQ9iJwpLRiiqbQrFtsAe8eB6dLMpQ-mV4wFqZp51EQtAViW0LL9Rb9z1pghaMhBdurNyKCr5r-dMgI8fPAUd5iEQ8lloz-BJ_dowSiotHiPMNgpQOuQ_3lMKZyWs9UGxyCzCJ5g52Pe28Qvd8KLZ5uyI6pOQZNBRHGD0QRjn9erW3tDGDWx-Teba77YiLlpGjpX9zxbruEun0n3BlorGX7QEncW9riLorDC8OnWPNvgL1Iu1d1sEYYFKdfJETfrBCcrDWjexHWtbBtZZEthztq1wPiqbtOw5INiTjV6Q";
clientcredentialheader = new Headers({'Content-Type':'application/json',
'Accept':'application/json', 'X-Requested-With': 'XMLHttpRequest',
'Authorization': this.getClientCredential()});
 authcredheader: any;
constructor(public http: Http,@Inject(PLATFORM_ID) private platformId: Object) {
}
getClientCredential() {
  var Bearer= 'Bearer' + ' ' + this.cdtk;
  return Bearer;
}
getAuthCredential(){
  if (isPlatformBrowser(this.platformId)) {
  var a = localStorage.getItem("token");
  var tjson =JSON.parse(a);
  if(tjson != null){
    var auth= 'Bearer' + ' ' +  tjson.token;
    return auth;
  }
}
}
genAuthHeader(){
  this.authcredheader = new Headers({'Content-Type': 'application/json',
  'Accept':'application/json',
  'Authorization': this.getAuthCredential()})
}

getBreedsInfo(): Observable<any> {
    return this.http.get('https://passport.petcart.in/breeddetails',
    {headers: this.clientcredentialheader})
    .pipe(map(
      (response: Response) => {
        return response.json().data;
      })
    );
  }

  getBreedInfoDetails(id): Observable<any> {
    return this.http.get('https://passport.petcart.in/breeddetails/' + id,
    {headers: this.clientcredentialheader})
      .pipe(map(
        (response: Response) => {
          return response.json().data;
        })
      );
  }

}